import { jsx as _jsx } from "react/jsx-runtime";
import hoistNonReactStatics from 'hoist-non-react-statics';
import { useNProgress } from './useNProgress';
export function withNProgress(BaseComponent) {
    const WithNProgress = (props) => {
        const hookProps = useNProgress(props);
        return _jsx(BaseComponent, { ...props, ...hookProps });
    };
    hoistNonReactStatics(WithNProgress, BaseComponent);
    return WithNProgress;
}
